import React, { useState, useContext, useEffect } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom"; // Importăm Navigate pentru redirecționare
import { AuthContext } from "../../context/AuthContext"; // Corectăm calea
import "./LogIn.css";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { currentUser, loading } = useContext(AuthContext); // Use loading state

  useEffect(() => {
    if (loading) return; // If still loading, don't do anything

    console.log("Current user in LoginPage:", currentUser); // Log current user for debugging

    if (currentUser) {
      // If the user is already logged in, redirect to the /admin page
      navigate("/admin");
    }
  }, [currentUser, loading, navigate]); // This effect runs when currentUser or loading changes

  const handleLogin = async () => {
    const auth = getAuth();

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      console.log("Logged in user:", userCredential.user); // Check if user is logged in correctly
    } catch (error) {
      setError("Eroare la autentificare. Verificați email-ul și parola.");
    }
  };

  // If still loading, show a loading spinner or message
  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner or custom loading component
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-box">
          <h2>Conectează-te</h2>
          <input
            className="input-field"
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            className="input-field"
            type="password"
            placeholder="Parolă"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button className="login-button" onClick={handleLogin}>
            Conectează-te
          </button>
          {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
